module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/public-views/public-views.component.html
// module id = ./src/app/public-views/public-views.component.html
// module chunks = main